import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { ContactUs, ProductFamily, Header, RelatedContent, Footer } from './Components';
import { 
  getPrimaryNavigationData,
  getSearchConfig,
  getLogoConfig,
  getHighlightKeyStatsData,
  getRelatedContentData,
  getContactUsData,
  getFooterNavigationData,
  getHomepageHeroCarouselData,
  getAnalytics
} from './util/dataLoader';
import { HighlightKeyStats } from 'Components/HighlightKeyStats';
import Analytics from 'Common/UI/client/components/Analytics';
import HomepageHeroV2 from 'Components/HomepageHeroV2';
import { HomepageHeroV2Props } from './Components/HomepageHeroV2/models';
// Load all navigation data from components-config.json
const navigationData = getPrimaryNavigationData();
const searchConfig = getSearchConfig();
const logoConfig = getLogoConfig();
const homepageHeroDataRaw = getHomepageHeroCarouselData();
const homepageHeroData: HomepageHeroV2Props['data'] | null = homepageHeroDataRaw
  ? { delay: homepageHeroDataRaw.delay || "5000", ...homepageHeroDataRaw }
  : null;
const highlightKeyStatsData = getHighlightKeyStatsData();
const relatedContentData = getRelatedContentData();
const contactUsData = getContactUsData();
const footerNavigationData = getFooterNavigationData();
const analyticsData = getAnalytics();
ReactDOM.render(
  <React.StrictMode>
    <div className="app-container">
      <Header 
        primaryNavigation={navigationData.data}
        searchConfig={searchConfig}
        logoConfig={logoConfig}
        clearIcon={navigationData.clearIcon}
        countrySelectorUrl={navigationData.countrySelectorUrl}
        svgCountryIcon={navigationData.svgCountryIcon}
      />
      <main className="main-content">
        <HomepageHeroV2 data={homepageHeroData} />
        <HighlightKeyStats data={highlightKeyStatsData} />
        <ProductFamily />
        <RelatedContent data={relatedContentData} />
        <ContactUs data={contactUsData} />
      </main>
      <Footer data={footerNavigationData} />
    </div>
    <Analytics data={analyticsData} />
    </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
